import { RATINGS } from 'constants/ponder';
import seededShuffle from './seededShuffle';

export const unansweredRatings = (ratings, upToPhase = Infinity) =>
  RATINGS.filter((rating) => rating.phase <= upToPhase && !ratings[rating.type]);

/** The order shown before stays; otherwise it is shuffled once per workout. */
export const ratingDisplayOrder = (rating, workoutSessionId, ratings) =>
  ratings[rating.type]?.displayOrder ||
  seededShuffle(
    rating.options.map((option) => option.value),
    `${workoutSessionId}:${rating.type}`,
  );
